import { IAccessBaseResponse } from '../../../types/list.interface'
import { endpoints } from '../endpoints'
import { getShippingServiceInstance } from '../Instances/shipping-service-instance'

export const accessSscc = (sscc: string, po: string): Promise<IAccessBaseResponse> => {
  const res = getShippingServiceInstance().get(`${endpoints.access}?sscc=${sscc}&po=${po}`)
  return res
}

export const accessFileUrl = (sscc: string, po: string): Promise<IAccessBaseResponse> => {
  const res = getShippingServiceInstance().get(`${endpoints.fileUrl}?sscc=${sscc}&po=${po}`)
  return res
}
